import React, { useEffect, useState } from 'react';

//import Scss
import './assets/scss/themes.scss';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//imoprt Route
import Route from './Routes';
function App() {


  return (
    <React.Fragment>
      <ToastContainer position="top-right" autoClose={3000} />
      <Route />


    </React.Fragment>
  );
}

export default App;
